import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const crossIcon: SvgIconData = {
  viewBox: '6.71 6.7 86.58 86.59',
  element: (
    <path d="M50 6.71a43.29 43.29 0 1 0 0 86.58A43.29 43.29 0 0 0 50 6.7zm21.9 56.05a6.47 6.47 0 1 1-9.15 9.15L50 59.15 37.24 71.91a6.47 6.47 0 1 1-9.15-9.15L40.85 50 28.09 37.24a6.47 6.47 0 1 1 9.15-9.15L50 40.85l12.76-12.76a6.47 6.47 0 1 1 9.15 9.15L59.15 50l12.76 12.76z" />
  ),
};
